document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector("header.new-header");
    if (!header) return;
    const openBtn = header.querySelector(".tab");
    const closeBtn = header.querySelector(".close-menu");
    const body = document.body;
    const dynamicBackground = document.querySelector(".dynamic-background");
    const serviceMenu = document.querySelector(".service-menu");
    const desktopParent = header.querySelector(".top-bar-inner");
    const mobileTarget = header.querySelector(".mobile-service-nav");

    let focusableElements = [], firstFocusable, lastFocusable;

    // Move service menu on mobile
    function moveServiceMenu() {
        const isMobile = window.innerWidth <= 768;
        if (!serviceMenu || !desktopParent || !mobileTarget) return;

        if (isMobile) {
            if (!mobileTarget.contains(serviceMenu)) {
                mobileTarget.appendChild(serviceMenu);
            }
        } else {
            if (!desktopParent.contains(serviceMenu)) {
                const referenceNode = desktopParent.querySelector(".close-menu");
                desktopParent.insertBefore(serviceMenu, referenceNode);
            }
        }
    }

    moveServiceMenu();
    window.addEventListener("resize", moveServiceMenu);

    // FOCUS TRAP - lock keyboard navigation in the menu until user leaves it
    function trapFocus(container) {
        focusableElements = Array.from(container.querySelectorAll(
            `a[href], button, textarea, input:not([type="hidden"]), select, [tabindex]:not([tabindex="-1"])`
        )).filter(el => !el.disabled && !el.getAttribute("aria-hidden"));
        if (!focusableElements.length) return;
        firstFocusable = focusableElements[0];
        lastFocusable = focusableElements[focusableElements.length - 1];
        firstFocusable.focus();
        document.addEventListener("keydown", focusTrapHandler);
    }

    function focusTrapHandler(e) {
        if (e.key !== "Tab") return;
        if (e.shiftKey) {
            if (document.activeElement === firstFocusable) { e.preventDefault(); lastFocusable.focus(); }
        } else { if (document.activeElement === lastFocusable) { e.preventDefault(); firstFocusable.focus(); } }
    }

    function releaseFocus() { document.removeEventListener("keydown", focusTrapHandler); }

    function closeMenu() {
        header.classList.remove("open");
        header.querySelectorAll(".subs").forEach(s => s.classList.remove("active", "animated"));
        header.querySelectorAll(".tab").forEach(t => t.classList.remove("active"));
        header.querySelectorAll(".subs-outer").forEach(s => s.style.height = "");
        if (dynamicBackground) dynamicBackground.style.height = "";
        body.classList.remove("backdrop");
        if (serviceMenu) { serviceMenu.classList.remove("none"); serviceMenu.classList.remove("flex"); }
        releaseFocus();
        openBtn?.focus();
    }

    openBtn?.addEventListener("click", () => {
        const isMobile = window.innerWidth <= 768;
        if (serviceMenu && !isMobile) { serviceMenu.classList.remove("flex"); serviceMenu.classList.add("none"); }
        setTimeout(() => { if (header.classList.contains("open")) trapFocus(header); }, 30);
    });

    function syncOpenMenuSizing() {
        if (!header.classList.contains("open")) return;

        const activeSubs = header.querySelector(".subs.active");
        const outer = activeSubs?.closest(".subs-outer");
        const isMobile = window.innerWidth <= 768;
        const isTablet = window.innerWidth > 768 && window.innerWidth < 1024;

        if (isMobile) {
            header.style.height = "";
            if (dynamicBackground) dynamicBackground.style.height = "100vh";
            if (outer && activeSubs) outer.style.height = activeSubs.offsetHeight + "px";
            return;
        }

        if (outer) outer.style.height = "";
        if (!activeSubs || !dynamicBackground) return;

        if (isTablet) {
            const height = activeSubs.offsetHeight + 200 + "px";
            header.style.height = height;
            dynamicBackground.style.height = height;
        } else {
            header.style.height = "";
            dynamicBackground.style.height = header.offsetHeight + activeSubs.offsetHeight + 40 + "px";
        }
    }

    let sizingFrame = null;
    window.addEventListener("resize", () => {
        if (sizingFrame) cancelAnimationFrame(sizingFrame);
        sizingFrame = requestAnimationFrame(syncOpenMenuSizing);
    });

    closeBtn?.addEventListener("click", closeMenu);
    document.addEventListener("keydown", e => { if (e.key === "Escape" && header.classList.contains("open")) closeMenu(); });
});